// Mobilní okno chatu SupportBoxu (≤ 768 px): vlastní rozvržení uvnitř iframu
// widgetu. Volá ho supportChat.js po načtení widgetu a při každém otevření.
//
// PROČ (iPhone Tomáše 2026-10-04, „takhle je to neakceptovatelné"): mobilní okno
// widgetu (webChat.css ver 5f4f05bd1a) stojí na pevných pozicích. Pole uvítacího
// okna má `top: 295px`, patička „Vytvořeno s ♥ v SupportBoxu" `position: absolute;
// bottom: 0`, okno `overflow-y: scroll` a iframe výšku `clientHeight` stránky.
// Klávesnice iOS zmenší jen viditelnou plochu (visualViewport): pole zajede pod
// ni, patička leží přes pole nebo nad ním, okno jde posouvat a při posunu obsahu
// leze nadpis pod ikony menu.
//
// Iframe je same-origin (widget ho píše `document.write`), takže do něj vkládáme
// vlastní styl: okno je sloupec hlavička → obsah → pole → patička, pole leží vždy
// u spodní hrany a roste s textem, výšku iframu drží supportChat.js podle
// visualViewport (okno = viditelná plocha nad klávesnicí). Pod 480 px výšky
// (otevřená klávesnice) patička ustoupí poli. Uvítací okno přestává být celé
// v barvě chatu: barvu nese hlavička jako v okně konverzace, obsah je světlý.
// Okna s formulářem kontaktu (`--user-info-question`, chat je dnes nepoužívá)
// mění jen scroll, ne rozvržení. Rozvržení je jen pro mobil (`html.bs-sbf-m`
// a `#supportBoxWebChat.mobile`, třídu `mobile` dává widget při vzniku podle
// šířky okna); okno 355×580 na desktopu dostane jen úpravu menu (`html.bs-sbf`).
//
// Menu okna (Tomáš 2026-10-04: „≡ nic nedělá", „zavření chci klasickou ikonu X,
// ne chevron"): widget zavírá okno konverzace šipkou dolů (`.menu-minimize`),
// uvítací okno křížkem (`.close`); obě mají TENTÝŽ handler (initHandleWelcomeOnClickClose
// webChat.js: markAsClose + redraw), takže v konverzaci jen ukážeme křížek místo
// šipky. Nabídka „≡" (`#menuBox`: Zvuk, v konverzaci Přeposlat na e-mail) se otevírá
// fokusem, ale webChat.css jí dává `display: none`, když je skryté okno Welcome,
// Opened i Offline, tedy právě v uvítacím okně DirectMessage: tam je „≡" mrtvé
// a nabízelo by jen zvuk, proto se tam nekreslí. V konverzaci funguje a zůstává.
//
// Tečka stavu před podtitulkem uvítání (`.subtitle::before`, červená offline,
// zelená online) se nekreslí (Tomáš 2026-10-04: „žádná červená tečka ani jsme
// offline"): hlavní řádek patří nákupnímu asistentovi, který odpovídá hned, stav
// kolegů nese menší řádek pod ním. Texty jsou nastavení chatu SupportBoxu.

export const FRAME_STYLE_ID = 'bs-chat-frame';
// třídy kořene iframu, pod kterými platí styl (i kvůli specifičnosti nad webChat.css):
// menu na desktopu i mobilu, rozvržení jen na mobilu
export const FRAME_CLASS_ANY = 'bs-sbf';
export const FRAME_CLASS = 'bs-sbf-m';
// výška pole: jeden řádek, s textem roste do MAX (pak se posouvá uvnitř)
export const COMPOSER_MIN = 48;
export const COMPOSER_MAX = 136;

// Bloky stylu po řadě: kořen iframu bez scrollu → okno jako sloupec (uvítací
// i konverzace) → uvítací okno (hlavička v barvě chatu, pod ní světlý obsah) →
// pole (bílá pilulka u spodní hrany, odeslání v jejím pravém dolním rohu) → okno
// konverzace (hlavička a pole stojí, posouvá se jen seznam zpráv; šipka „dolů"
// nad polem) → patička SupportBoxu pod polem, nikdy přes něj → nízké okno
// (otevřená klávesnice): patička ustoupí, hlavička se zmenší. `touch-action: none`
// na okně: tah prstem okno ani stránku pod ním neposune (zprávy a dlouhý text
// v poli mají `pan-y`).

const CSS = `
html.bs-sbf .supportBoxWebChat-window .subtitle::before { display: none; }
html.bs-sbf #supportBoxWebChatDirectMessage .menu-content,
html.bs-sbf #supportBoxWebChatOpened .menu-minimize { display: none; }
html.bs-sbf #supportBoxWebChatOpened .menu .close.hidden { display: flex; }

html.bs-sbf-m, html.bs-sbf-m body { height: 100%; margin: 0; overflow: hidden; overscroll-behavior: none; }
html.bs-sbf-m #supportBoxWebChat.mobile { --bs-sbf-love-h: 24px; }

html.bs-sbf-m #supportBoxWebChat.mobile .supportBoxWebChat-window--welcome:not(.hidden),
html.bs-sbf-m #supportBoxWebChat.mobile #supportBoxWebChatOpened:not(.hidden) {
  display: flex; flex-direction: column; box-sizing: border-box;
  top: 0; right: 0; bottom: 0; left: 0; width: auto; max-width: none; height: auto;
  overflow: hidden; overscroll-behavior: none; box-shadow: none;
  background: var(--bs-sbf-surface) !important;
  touch-action: none;
}
html.bs-sbf-m #supportBoxWebChat.mobile #supportBoxWebChatOpened::after { display: none; }
html.bs-sbf-m #supportBoxWebChat.mobile .supportBoxWebChat-window--user-info-question { overscroll-behavior: contain; }
html.bs-sbf-m #supportBoxWebChat.mobile .menu { top: 2px; touch-action: none; }

html.bs-sbf-m #supportBoxWebChat.mobile .supportBoxWebChat-window--welcome > .menu-spacer,
html.bs-sbf-m #supportBoxWebChat.mobile .supportBoxWebChat-window--welcome > h1,
html.bs-sbf-m #supportBoxWebChat.mobile .supportBoxWebChat-window--welcome > .subtitle,
html.bs-sbf-m #supportBoxWebChat.mobile .supportBoxWebChat-window--welcome > .operators {
  flex: none; margin: 0; background: var(--bs-sbf-primary); touch-action: none;
}
html.bs-sbf-m #supportBoxWebChat.mobile .supportBoxWebChat-window--welcome > .menu-spacer { height: 44px; }
html.bs-sbf-m #supportBoxWebChat.mobile .supportBoxWebChat-window--welcome > h1 {
  padding: 0 24px 6px; font-size: 22px; font-weight: 600; line-height: 1.25;
}
html.bs-sbf-m #supportBoxWebChat.mobile .supportBoxWebChat-window--welcome > .subtitle {
  padding: 0 24px 18px; font-size: 14px; line-height: 1.4;
}
html.bs-sbf-m #supportBoxWebChat.mobile .supportBoxWebChat-window--welcome > .operators { display: flex; height: auto; padding-bottom: 12px; }
html.bs-sbf-m #supportBoxWebChat.mobile .supportBoxWebChat-window--welcome > .operators:empty { display: none; }
html.bs-sbf-m #supportBoxWebChat.mobile .supportBoxWebChat-window--welcome > p {
  flex: 1 1 auto; min-height: 0; margin: 0; padding: 20px 24px; overflow: hidden;
  color: var(--bs-sbf-ink-3) !important; font-size: 14px; font-weight: 400; line-height: 1.5;
  opacity: 1; touch-action: none;
}
html.bs-sbf-m #supportBoxWebChat.mobile .supportBoxWebChat-window--welcome > p::before { filter: invert(1); opacity: 0.55; }

html.bs-sbf-m #supportBoxWebChat.mobile .supportBoxWebChat-window--welcome > textarea,
html.bs-sbf-m #supportBoxWebChat.mobile #supportBoxWebChatArea > textarea {
  position: static; flex: none; display: block; box-sizing: border-box;
  height: var(--bs-sbf-ta-h, ${COMPOSER_MIN}px) !important; min-height: ${COMPOSER_MIN}px; max-height: ${COMPOSER_MAX}px;
  padding: 13px 56px 13px 18px; border: 1px solid var(--bs-sbf-border); border-radius: 24px;
  box-shadow: none; background: #fff; color: var(--bs-sbf-ink);
  font: 16px/20px "Open Sans", Arial, sans-serif; text-align: left;
  resize: none; overflow-y: auto; overscroll-behavior: contain; touch-action: pan-y;
}
html.bs-sbf-m #supportBoxWebChat.mobile .supportBoxWebChat-window--welcome > textarea { width: auto; margin: 8px 12px; }
html.bs-sbf-m #supportBoxWebChat.mobile #supportBoxWebChatArea > textarea { width: 100%; margin: 0; padding-right: 90px; }
html.bs-sbf-m #supportBoxWebChat.mobile .supportBoxWebChat-window--welcome > input[type=submit],
html.bs-sbf-m #supportBoxWebChat.mobile #supportBoxWebChatArea > input[type=submit] {
  top: auto; width: 40px; height: 40px; margin: 0; border-radius: 50%; background-position: 55% 50%;
}
html.bs-sbf-m #supportBoxWebChat.mobile .supportBoxWebChat-window--welcome > input[type=submit] {
  right: 16px; bottom: calc(var(--bs-sbf-love-h) + 12px);
}
html.bs-sbf-m #supportBoxWebChat.mobile #supportBoxWebChatArea {
  position: relative; flex: none; padding: 8px 12px; border: 0; background: var(--bs-sbf-surface); touch-action: none;
}
html.bs-sbf-m #supportBoxWebChat.mobile #supportBoxWebChatArea > input[type=submit] { right: 16px; bottom: 12px; }
html.bs-sbf-m #supportBoxWebChat.mobile #supportBoxWebChatArea > .sb-attachment { top: auto; right: 60px; bottom: 14px; }

html.bs-sbf-m #supportBoxWebChat.mobile #supportBoxWebChatHeader,
html.bs-sbf-m #supportBoxWebChat.mobile #operator { flex: none; touch-action: none; }
html.bs-sbf-m #supportBoxWebChat.mobile #supportBoxWebChatMessages {
  flex: 1 1 auto; min-height: 0; height: auto !important;
  overflow-y: auto; overscroll-behavior: contain; touch-action: pan-y;
}
html.bs-sbf-m #supportBoxWebChat.mobile #scroll-down-arrow {
  top: auto !important; bottom: calc(var(--bs-sbf-ta-h, ${COMPOSER_MIN}px) + 28px + var(--bs-sbf-love-h)) !important;
  left: 50% !important; margin: 0 0 0 -20px !important;
}

html.bs-sbf-m #supportBoxWebChat.mobile .supportBoxWebChat-love-light {
  position: static; flex: none; box-sizing: border-box; width: auto; height: var(--bs-sbf-love-h);
  margin: 0; padding: 0 16px 6px; border-radius: 0; background: transparent;
  font-size: 11px; line-height: 18px; text-align: center; touch-action: none;
}
html.bs-sbf-m #supportBoxWebChat.mobile .supportBoxWebChat-love-light a { padding: 0; }

@media (max-height: 480px) {
  html.bs-sbf-m #supportBoxWebChat.mobile { --bs-sbf-love-h: 0px; }
  html.bs-sbf-m #supportBoxWebChat.mobile .supportBoxWebChat-love-light { display: none; }
  html.bs-sbf-m #supportBoxWebChat.mobile .supportBoxWebChat-window--welcome > h1 { font-size: 18px; }
  html.bs-sbf-m #supportBoxWebChat.mobile .supportBoxWebChat-window--welcome > .subtitle { padding-bottom: 12px; }
  html.bs-sbf-m #supportBoxWebChat.mobile .supportBoxWebChat-window--welcome > p { padding: 12px 24px; }
}
`;

/** Text vkládaného stylu (export kvůli testu a sondám). */
export function frameCss() {
  return CSS;
}

// Barvy z tokenů stránky (jeden zdroj pravdy), barva chatu z nastavení widgetu
// (`.sb-color__primary-bg` hlavičky konverzace, inline styl widgetu).
const TOKENS = [
  ['--bs-sbf-ink', '--bs-c-ink', '#16181d'],
  ['--bs-sbf-ink-3', '--bs-c-ink-3', '#5f6670'],
  ['--bs-sbf-border', '--bs-c-border-input', '#e1e4e9'],
  ['--bs-sbf-surface', '--bs-c-surface-3', '#fafbfc'],
];

function primaryOf(doc) {
  const el = doc.getElementById('supportBoxWebChatHeader') || doc.querySelector('.sb-color__primary-bg');
  const c = el ? doc.defaultView.getComputedStyle(el).backgroundColor : '';
  return c && !/^(transparent|rgba\(0, 0, 0, 0\))$/.test(c) ? c : '#c0272e';
}

function frameDoc(iframe) {
  try {
    return (iframe && iframe.contentDocument) || null;
  } catch (e) {
    return null; // cizí původ (widget by musel změnit způsob vložení)
  }
}

/**
 * Pole roste s textem (widget mu na mobilu drží pevných 80 px): výška jde přes
 * proměnnou okna, kterou čte i šipka „dolů" nad polem. Volá se na `input`
 * a po odeslání zprávy (widget pole vyprázdní bez eventu).
 */
export function fitComposer(ta) {
  const win = ta && ta.closest ? ta.closest('#supportBoxWebChatOpened, .supportBoxWebChat-window') : null;
  if (!win) return;
  win.style.setProperty('--bs-sbf-ta-h', 'auto');
  const h = Math.min(COMPOSER_MAX, Math.max(COMPOSER_MIN, ta.scrollHeight + 2));
  win.style.setProperty('--bs-sbf-ta-h', h + 'px');
}

/**
 * Seznam zpráv dočtený do konce zůstane u konce i po změně výšky okna: otevřená
 * klávesnice okno zkrátí odspodu a poslední zprávy by zajely pod pole.
 */
export function keepAtBottom(iframe, apply) {
  const doc = frameDoc(iframe);
  const list = doc && doc.documentElement.classList.contains(FRAME_CLASS) ? doc.getElementById('supportBoxWebChatMessages') : null;
  const stick = !!list && list.clientHeight > 0 && list.scrollHeight - list.scrollTop - list.clientHeight < 24;
  apply();
  if (stick) list.scrollTop = list.scrollHeight;
}

/** Přepočet všech polí okna (po odeslání zprávy, po otevření). */
export function refitComposers(iframe) {
  const doc = frameDoc(iframe);
  if (!doc || !doc.documentElement.classList.contains(FRAME_CLASS)) return;
  doc.querySelectorAll('#supportBoxWebChat textarea[name="message"]').forEach(fitComposer);
}

// Okna s polem zprávy, jehož text si widget drží jako koncept (initTextAreaResize
// webChat.js: na `input` ho uloží do localStorage `supportboxChat_text` a okno
// konverzace ho při každém překreslení vrací do pole). Offline okno (formulář
// s e-mailem) mezi nimi není.
const COMPOSER_WINDOWS = ['#supportBoxWebChatOpened', '#supportBoxWebChatWelcome', '#supportBoxWebChatDirectMessage'];

function composers(iframe) {
  const doc = frameDoc(iframe);
  if (!doc) return [];
  const out = [];
  COMPOSER_WINDOWS.forEach(function (sel) {
    const win = doc.querySelector(sel);
    const ta = win && win.querySelector('textarea[name="message"]');
    if (ta) out.push({ ta: ta, shown: !win.classList.contains('hidden') });
  });
  return out;
}

// Zpráva zákazníka v seznamu zpráv = konverzace začala (tentýž selektor používá widget
// sám, hasMessageTypeInMessage webChat.js ver 0b3be71aab). Okno konverzace samo o tom nic
// neříká: widget ho ukazuje i čerstvému návštěvníkovi s proměnnými odesílatele.
const CUSTOMER_MESSAGE = '#supportBoxWebChatMessages .message-type_message-in';

/** Konverzace v okně widgetu už má zprávu od zákazníka. */
export function hasCustomerMessage(iframe) {
  const doc = frameDoc(iframe);
  return !!(doc && doc.querySelector(CUSTOMER_MESSAGE));
}

function caretToEnd(ta) {
  try {
    ta.setSelectionRange(ta.value.length, ta.value.length);
  } catch (e) { /* pole bez výběru */ }
}

/**
 * Předvyplní pole zprávy v otevřeném okně (chat ze stránky Stav objednávky,
 * dotaz k produktu na detailu). Jen prázdné pole: rozepsaný text zákazníka se
 * nepřepisuje. `input` je nutný, widget na něj odemyká odeslání a ukládá koncept,
 * odeslání pak čte `textarea.value`. `focus` = pole dostane fokus (desktop; na
 * mobilu by vyjela klávesnice, widget tam pole sám nefokusuje). `fresh` = jen do
 * konverzace bez zprávy zákazníka (zákazník, který se k chatu vrací, předponu
 * nedostane). `false` = nic nevyplněno (okno ani pole tu není, jiný tvar widgetu,
 * text v poli, konverzace začala).
 *
 * Kurzor patří za text: text je v poli zalomený na víc řádků a první klik do něj
 * by kurzor postavil doprostřed, dotaz by skončil mezi číslem a e-mailem (test
 * na ostré 9. 10. 2026). Proto ho na konec vrátí i první klik do nezměněného textu.
 */
export function fillComposer(iframe, text, focus, fresh) {
  const hit = composers(iframe).filter(function (c) {
    return c.shown && !c.ta.disabled;
  })[0];
  if (!hit || hit.ta.value !== '') return false;
  if (fresh && hasCustomerMessage(iframe)) return false;
  const ta = hit.ta;
  ta.value = text;
  ta.dispatchEvent(new Event('input'));
  if (focus) {
    try {
      ta.focus({ preventScroll: true });
    } catch (e) { /* starý prohlížeč bez options */ }
  }
  caretToEnd(ta);
  // kurzor klik postaví až po události, proto o tik později
  ta.addEventListener(
    'click',
    function () {
      setTimeout(function () {
        if (ta.value === text) caretToEnd(ta);
      }, 0);
    },
    { once: true }
  );
  return true;
}

/**
 * Vyprázdní pole, která drží přesně předvyplněný text (zákazník nic nedopsal
 * ani neodeslal), ať se koncept widgetu nevrací v chatu otevřeném jinde.
 */
export function clearComposer(iframe, text) {
  composers(iframe).forEach(function (c) {
    if (c.ta.value !== text) return;
    c.ta.value = '';
    c.ta.dispatchEvent(new Event('input'));
  });
}

/**
 * Vloží styl do iframu widgetu (idempotentní): menu vždy, rozvržení jen
 * v mobilním okně. `false` = iframe tu není nebo do něj nejde sáhnout,
 * `'menu'` = desktopové okno (jen menu), `true` = mobilní okno.
 */
export function styleFrame(iframe, pageRoot) {
  const doc = frameDoc(iframe);
  const root = doc && doc.getElementById('supportBoxWebChat');
  if (!root) return false;
  const html = doc.documentElement;
  if (!doc.getElementById(FRAME_STYLE_ID)) {
    const style = doc.createElement('style');
    style.id = FRAME_STYLE_ID;
    style.textContent = CSS;
    (doc.head || html).appendChild(style);
  }
  html.classList.add(FRAME_CLASS_ANY);
  if (!root.classList.contains('mobile')) return 'menu';
  html.classList.add(FRAME_CLASS);
  const page = pageRoot ? getComputedStyle(pageRoot) : null;
  TOKENS.forEach(function (t) {
    const v = page ? page.getPropertyValue(t[1]).trim() : '';
    html.style.setProperty(t[0], v || t[2]);
  });
  html.style.setProperty('--bs-sbf-primary', primaryOf(doc));
  doc.querySelectorAll('#supportBoxWebChat textarea[name="message"]').forEach(function (ta) {
    if (ta.__bsFit) return;
    ta.__bsFit = true;
    ta.addEventListener('input', function () {
      fitComposer(ta);
    });
    fitComposer(ta);
  });
  return true;
}
